import {AxiosError} from 'axios';
import {UseQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';
import {useQuery} from '@eksab/hooks';

import {Member} from '../types';

type QueryParams = {
  q: string | undefined;
  skipGroup?: number | string;
};

export function useUsersQuery({q, skipGroup}: QueryParams, options?: UseQueryOptions<Member[], AxiosError>) {
  return useQuery<Member[], AxiosError>(
    ['users', skipGroup, q],
    () =>
      api.get<{data: Member[]}>('v2/users/search', {params: {q, 'skip-group': skipGroup}}).then((res) => res.data.data),
    {
      ...options,
      enabled: !!q && (options?.enabled ?? true),
    },
  );
}
